var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66199 1.73951C9.84664 1.65747 10.0537 1.64575 10.2447 1.70435L10.3387 1.73951L17.8387 5.07183C18.1404 5.20585 18.3316 5.50339 18.3337 5.82751L18.3286 5.9254L17.8516 10.2184C17.6078 12.4128 16.4103 14.3837 14.5857 15.6118L14.3724 15.7502L10.442 18.2067C10.2018 18.3568 9.90421 18.3735 9.65125 18.2567L9.55869 18.2067L5.62826 15.7502C3.75597 14.58 2.49816 12.647 2.18147 10.4706L2.14912 10.2184L1.67212 5.9254C1.63567 5.59734 1.79612 5.28216 2.07489 5.1168L2.16199 5.07183L9.66199 1.73951ZM10.0004 3.41294L3.39592 6.34735L3.80559 10.0344C3.99396 11.7297 4.91419 13.2535 6.31729 14.21L6.51159 14.3369L10.0004 16.5173L13.4891 14.3369C14.9356 13.4328 15.9105 11.9434 16.1649 10.2645L16.1951 10.0344L16.6048 6.34735L10.0004 3.41294ZM11.8451 6.98522C12.1294 6.62333 12.6533 6.56047 13.0152 6.84481C13.3492 7.10728 13.4285 7.57385 13.2151 7.92872L13.1556 8.01492L9.82227 12.1815C9.53565 12.5463 9.01285 12.6024 8.65678 12.3257L8.57775 12.256L6.9111 10.5893C6.58566 10.2639 6.58566 9.73623 6.9111 9.4108C7.2115 9.1104 7.68419 9.08729 8.0111 9.34148L8.08961 9.4108L9.09207 10.4133L11.8451 6.98522Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.17024df4.svg";
export { ForwardRef as ReactComponent };